// import {
//     Autocomplete,
//     AutocompleteRenderInputParams,
//     Box,
//     FormControl,
//     TextField,
// } from '@mui/material';
import { Field, FieldProps, getIn } from 'formik';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';


import NowPaymentsApi from "@nowpaymentsio/nowpayments-api-js"
import { Box, CircularProgress, FormControl, TextField } from '@material-ui/core';
import Autocomplete, { AutocompleteRenderInputParams } from '@material-ui/lab/Autocomplete';
import { GetCurrenciesReturn } from '@nowpaymentsio/nowpayments-api-js/src/actions/get-currencies';
import { IGetEstimatePrice, Error as NowPaymentsError } from '@nowpaymentsio/nowpayments-api-js/src/types';
import { GetEstimatePriceReturn } from '@nowpaymentsio/nowpayments-api-js/src/actions/get-estimate-price';

const npApi = new NowPaymentsApi({ apiKey: "XARXN19-6KG4H51-KP8JFHP-XS3YCSV" })

export interface CurrencyFieldProps {
    disabled: boolean;
    currencyHolderId?: string;
    label?: string;
}
export const CurrencyField: FC<
    CurrencyFieldProps & FieldProps<string[], string[]>
> = ({
    disabled = false,
    currencyHolderId,
    label = 'Source Currency',
    field,
    form: { values, touched, errors, handleBlur, handleChange, setFieldValue },
    ...props
}) => {
        const [loading, setLoading] = useState<boolean>(false);
        const [currencyData, setCurrencyData] = useState<string[]>([]);
        const [estimateCost, setEstimateCost] = useState<string>('');

        // Auto populate currencies when there is only one
        useEffect(() => {
            async function fetchCurrencies() {
                setLoading(true);
                const data: GetCurrenciesReturn | NowPaymentsError = await npApi.getCurrencies();
                if ('currencies' in data) {
                    const currencies = [...data.currencies];
                    currencies.sort();
                    setCurrencyData(currencies);
                }
                setLoading(false);
            }
            fetchCurrencies()
        }, []);



        // useEffect(() => {
        //     async function fetchEstimate() {

        //         const currency: string = getIn(values, field.name);
        //         const request: IGetEstimatePrice = {
        //             amount: 50,
        //             currency_from: 'eur',
        //             currency_to: currency

        //         };
        //         const data: GetEstimatePriceReturn | NowPaymentsError = await npApi.getEstimatePrice(request);

        //         // currency_from: string
        //         // amount_from: number
        //         // currency_to: string
        //         // estimated_amount: number
        //         if ('estimated_amount' in data) {
        //             setEstimateCost(`${data.estimated_amount}`);
        //         }
        //     }



        //     if (getIn(values, field.name).length > 0) {
        //         try {
        //             fetchEstimate()
        //         } catch (error) {
        //         }
        //     }

        // }, [field.name, values]);


        // 

        return (
            <>
                {/* <pre>{JSON.stringify(touched, null, 2)}</pre> */}
                {/* <pre>{JSON.stringify(errors, null, 2)}</pre> */}
                {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                {loading && currencyData?.length === 0 &&
                    <CircularProgress />
                }
                {!loading && currencyData?.length === 0 &&
                    <Box sx={{ mb: '32px' }}>
                        {'No Currencies Found'}
                    </Box>}
                {currencyData && currencyData?.length > 0 && (
                    <FormControl fullWidth margin="normal">
                        <Field
                            component={Autocomplete}
                            name={`${field.name}`}
                            fullWidth
                            value={currencyData.find(x => x === getIn(values, field.name)) || null}
                            onBlur={handleBlur(`${field.name}`)}
                            onChange={(e: any, value: string) => {
                                setFieldValue(
                                    `${field.name}`,
                                    value !== null ? value : '',
                                );
                                handleChange(`${field.name}`)
                            }}
                            disabled={disabled || currencyData?.length === 1}
                            options={currencyData}
                            autoHighlight
                            variant="outlined"
                            filterOptions={(
                                options: Array<string>,
                                state: { inputValue: string },
                            ): Array<string> => {
                                return options.filter(
                                    (x) =>
                                        x
                                            ?.toLowerCase()
                                            ?.includes(state.inputValue.toLowerCase())

                                );
                            }}
                            // isOptionEqualToValue={(
                            //     option: string,
                            //     value: string | null,
                            // ) => option === value}
                            getOptionLabel={(option: string) =>
                                `${option}`
                            }
                            // renderOption={(props: any, option: string) => (
                            //     <Box
                            //         key={option}
                            //         component="li"
                            //         {...props}
                            //     >
                            //         {`${JSON.stringify(option)}`}
                            //     </Box>
                            // )}
                            renderInput={(params: AutocompleteRenderInputParams) => (
                                <>
                                    <TextField
                                        {...params}
                                        label={label}
                                        error={Boolean(
                                            getIn(touched, field.name) &&
                                            getIn(errors, field.name),
                                        )}
                                        helperText={
                                            (getIn(touched, field.name) &&
                                                getIn(errors, field.name)) || estimateCost
                                        }
                                        inputProps={{
                                            ...params.inputProps,
                                            autoComplete: 'new-password',
                                        }}
                                        InputProps={{
                                            ...params.InputProps,

                                        }}

                                    />
                                </>
                            )}
                        ></Field>
                    </FormControl>
                )
                }
            </>
        );
    };
